import React, { useState, useEffect } from 'react';
import './ContributorMapsSection.css';

const ContributorMapsSection = ({
  currentCity,
  onLoadMap,
  allRestaurants
}) => {
  const [contributorMaps, setContributorMaps] = useState([]);

  // Sample data for testing - will be replaced with Firebase later
  const sampleMaps = [
    // Santa Barbara maps
    {
      mapId: 'sample-sb-1',
      contributorId: 'user-123',
      contributorName: 'Sarah Chen',
      contributorAvatar: 'https://i.pravatar.cc/150?img=1',
      mapTitle: 'Hidden Gems of Santa Barbara',
      mapDescription: 'My personal favorites off the beaten path - authentic local spots that tourists usually miss.',
      cityId: 'santa-barbara',
      category: 'all',
      restaurantIds: [],
      thumbnailImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800',
      createdAt: new Date('2024-01-15'),
      isPublished: true,
      totalViews: 1247,
      totalClicks: 89
    },
    {
      mapId: 'sample-sb-2',
      contributorId: 'user-456',
      contributorName: 'Marcus Rodriguez',
      contributorAvatar: 'https://i.pravatar.cc/150?img=12',
      mapTitle: 'Best Coffee & Breakfast',
      mapDescription: 'Start your day right with these carefully curated breakfast spots and coffee shops.',
      cityId: 'santa-barbara',
      category: 'cafes',
      restaurantIds: [],
      thumbnailImage: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800',
      createdAt: new Date('2024-02-01'),
      isPublished: true,
      totalViews: 856,
      totalClicks: 67
    },
    // Carmel maps
    {
      mapId: 'sample-cm-1',
      contributorId: 'user-789',
      contributorName: 'Elena Kowalski',
      contributorAvatar: 'https://i.pravatar.cc/150?img=5',
      mapTitle: 'Romantic Date Night in Carmel',
      mapDescription: 'Intimate dining experiences perfect for special occasions and romantic evenings.',
      cityId: 'carmel-monterey',
      category: 'restaurants',
      restaurantIds: [],
      thumbnailImage: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800',
      createdAt: new Date('2024-01-20'),
      isPublished: true,
      totalViews: 2103,
      totalClicks: 156
    },
    // San Francisco maps
    {
      mapId: 'sample-sf-1',
      contributorId: 'user-234',
      contributorName: 'James Wu',
      contributorAvatar: 'https://i.pravatar.cc/150?img=13',
      mapTitle: 'SF Mission District Favorites',
      mapDescription: 'The best taquerias, cafes, and hidden bars in the Mission.',
      cityId: 'san-francisco',
      category: 'all',
      restaurantIds: [],
      thumbnailImage: 'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=800',
      createdAt: new Date('2024-02-10'),
      isPublished: true,
      totalViews: 1834,
      totalClicks: 142
    }
  ];

  useEffect(() => {
    // Filter maps for current city
    if (currentCity) {
      const cityMaps = sampleMaps.filter(map =>
        map.cityId === currentCity.toLowerCase() && map.isPublished
      );
      setContributorMaps(cityMaps);
    }
  }, [currentCity]);

  const handleMapClick = (map) => {
    if (onLoadMap) {
      onLoadMap(map);
    }
  };

  // Don't render if no maps available
  if (contributorMaps.length === 0) {
    return null;
  }

  return (
    <div className="contributor-maps-section">
      <div className="contributor-maps-header">
        <h2>Curated Guides</h2>
        <p>Personalized collections from Artifex contributors</p>
      </div>

      <div className="contributor-maps-grid">
        {contributorMaps.map(map => (
          <div
            key={map.mapId}
            className="contributor-map-card"
            onClick={() => handleMapClick(map)}
          >
            <div className="map-card-image-wrapper">
              <div
                className="map-card-image"
                style={{ backgroundImage: `url(${map.thumbnailImage})` }}
              />
            </div>

            <div className="map-card-details">
              <h3 className="map-card-title">{map.mapTitle}</h3>

              <div className="map-card-contributor">
                <img
                  src={map.contributorAvatar}
                  alt={map.contributorName}
                  className="contributor-avatar"
                />
                <span className="contributor-name">by {map.contributorName}</span>
              </div>

              <p className="map-card-description">{map.mapDescription}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContributorMapsSection;
